/** Consent filter values sent to POST /api/v1/contact/filter (property: consentStatus, filterType: equals). */
export type ConsentFilterValue =
  | "concedido"
  | "pendente"
  | "não concedido"
  | "cancelado"
  | "";

export const CONSENT_FILTER_VALUES = {
  ALL: "" as ConsentFilterValue,
  GRANTED: "concedido" as ConsentFilterValue,
  PENDING: "pendente" as ConsentFilterValue,
  NOT_GRANTED: "não concedido" as ConsentFilterValue,
  CANCELED: "cancelado" as ConsentFilterValue,
} as const;

export type ContactSortField =
  | "firstName"
  | "lastName"
  | "email"
  | "addressCity"
  | "addressState"
  | "active"
  | "consentStatus";

export type SortDirection = "asc" | "desc";
